const Text = {
	baseStyle: {
		lineHeight: '10'
	}
}

export default Text